// src/firebase.js (or .ts)
import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyDXfZl6iRGMid3NFkiZ9h2eQRdtDM9ipOA",
  authDomain: "code-forge-development.firebaseapp.com",
  projectId: "code-forge-development",
  storageBucket: "code-forge-development.firebasestorage.app",
  messagingSenderId: "662506868390",
  appId: "1:662506868390:web:dc9581417a563c067cae67",
  measurementId: "G-FDEM6Q0C1L"
};

// Prevent re-init during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Core services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app, 'us-central1')

// Analytics (browser-only, guards SSR/tests)
let analytics = null
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app)
  })
}

export { app, auth, db, storage, functions, analytics }